import React from "react";

import styles from "./userProfileBar.module.scss";

type AvatarProps = {
	firstNameCharacter: string;
	lastNameCharacter: string;
};

const Avatar = ({
	firstNameCharacter = "",
	lastNameCharacter = "",
}: AvatarProps) => {
	return (
		<div className={styles.avatarHolder}>
			<div className={styles.avatarLogo}>
				<span className="text-uppercase">{firstNameCharacter}</span>
				<span className="text-uppercase">{lastNameCharacter}</span>
			</div>
		</div>
	);
};

export default Avatar;
